export default __webpack_public_path__ + "static/media/330_dummy2016-asia-restaurant01-mobile-de.2980b933.png";